export default () => ({
    view: 'edit',
    documentId: null,
    eventId: null,
    document: {},
    section: {},
    field: {},

    showSectionModal: false,
    showDeleteSectionModal: false,
    showFieldModal: false,
    showDeleteFieldModal: false,
    dragging: false,
});
